import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EnvironmentService } from '@hdms/shared/util-core';

import { RECAPTCHA_V3_SITE_KEY, RecaptchaService } from './recaptcha.service';

const getRecaptchaV3SiteKey = (envService: EnvironmentService): string => envService.recaptchaV3PublicKey;

@NgModule({
  imports: [CommonModule],
  providers: [
    RecaptchaService,
    { provide: RECAPTCHA_V3_SITE_KEY, useFactory: getRecaptchaV3SiteKey, deps: [EnvironmentService] }
  ]
})
export class RecaptchaModule {}

export * from './recaptcha.service';
